import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts, appTypography } from "styles/appThemeFonts";
import {
  appThemeRadius,
  appThemeShadow,
  appThemeSize,
  appThemeSpace,
  appThemeTransition,
  appThemeZIndex,
} from "styles/appThemeTokens";
import { HEADER_HEIGHT } from "./TopHeader.constants";

export const headerBarSx = {
  flex: "0 0 auto",
  display: "flex",
  alignItems: "center",
  height: HEADER_HEIGHT,
  backgroundColor: appThemeColors.background.paper,
  borderBottom: `1px solid ${appThemeColors.border.default}`,
  padding: `0 ${appThemeSpace.xl} 0 ${appThemeSpace.xxl}`,
  position: "relative",
  zIndex: appThemeZIndex.header,
};

export const headerLeftSx = {
  display: "flex",
  alignItems: "center",
  gap: appThemeSpace.sm,
};

export const headerLogoWrapSx = {
  display: "flex",
  alignItems: "center",
  flex: "0 0 auto",
};

export const headerLogoButtonSx = {
  display: "flex",
  alignItems: "center",
  border: 0,
  background: "none",
  padding: 0,
  cursor: "pointer",
};

export const headerLogoSx = {
  height: appThemeSize.headerLogoHeight,
  width: "auto",
  display: "block",
  marginLeft: appThemeSpace.lg,
};

export const headerSpacerSx = {
  flex: 1,
};

export const headerRightSx = {
  display: "flex",
  alignItems: "center",
  gap: appThemeSpace.lg,
};

export const HeaderActionsGroup = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 0,
});

export const headerDividerSx = {
  width: "1px",
  minWidth: "1px",
  height: appThemeSize.headerDividerHeight,
  backgroundColor: appThemeColors.border.default,
  flex: "0 0 auto",
  alignSelf: "center",
};

export const iconButtonBaseSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: 0,
  cursor: "pointer",
  borderRadius: appThemeRadius.md,
  padding: 0,
  minWidth: 0,
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: appThemeColors.background.soft,
  },
};

export const navCollapseButtonSx = {
  ...iconButtonBaseSx,
  width: appThemeSize.iconButtonSm,
  height: appThemeSize.iconButtonSm,
  color: appThemeColors.text.faint,
  "& .MuiSvgIcon-root": {
    width: appThemeSize.collapseIcon,
    height: appThemeSize.collapseIcon,
  },
};

export const getNavCollapseIconSx = (isCollapsed) => ({
  transform: isCollapsed ? "rotate(180deg)" : "none",
  transition: appThemeTransition.iconRotate,
});

export const railActionButtonSx = {
  ...iconButtonBaseSx,
  width: appThemeSize.iconButton,
  height: appThemeSize.railActionHeight,
  color: appThemeColors.text.faint,
  "& .MuiSvgIcon-root": {
    width: appThemeSize.collapseIcon,
    height: appThemeSize.collapseIcon,
  },
};

export const getRailActionButtonActiveSx = (isActive) => ({
  ...railActionButtonSx,
  backgroundColor: isActive ? appThemeColors.background.tint : "transparent",
  color: isActive ? appThemeColors.blue.dark : appThemeColors.text.faint,
  "&:hover": {
    backgroundColor: isActive
      ? appThemeColors.background.tint
      : appThemeColors.background.soft,
  },
});

export const userInitialsButtonSx = {
  ...iconButtonBaseSx,
  width: appThemeSize.iconButton,
  height: appThemeSize.railActionHeight,
  ...appTypography.initials,
  color: appThemeColors.blue.dark,
  backgroundColor: appThemeColors.background.tint,
  "&:hover": {
    backgroundColor: appThemeColors.background.selected,
  },
};

export const userMenuOpenButtonSx = {
  ...userInitialsButtonSx,
};

export const menuPaperSx = {
  marginTop: appThemeSpace.xs,
  backgroundColor: appThemeColors.background.paper,
  border: `1px solid ${appThemeColors.border.default}`,
  borderRadius: appThemeRadius.lg,
  boxShadow: appThemeShadow.menu,
  overflow: "hidden",
};

export const menuListSx = {
  padding: appThemeSpace.md,
};

export const menuSectionLabelSx = {
  ...appTypography.sectionLabel,
  color: appThemeColors.text.faint,
  padding: `${appThemeSpace.sm} ${appThemeSpace.lg} 5px`,
};

export const menuItemSx = {
  display: "flex",
  alignItems: "center",
  gap: appThemeSpace.lg,
  width: "100%",
  textAlign: "left",
  padding: `${appThemeSpace.md} ${appThemeSpace.lg}`,
  border: 0,
  background: "none",
  borderRadius: appThemeRadius.md,
  cursor: "pointer",
  ...appTypography.menuItem,
  color: appThemeColors.text.primary,
  "&:hover": {
    backgroundColor: appThemeColors.background.rule,
  },
};

export const menuItemActiveSx = {
  backgroundColor: appThemeColors.background.selected,
  "&:hover": {
    backgroundColor: appThemeColors.background.selected,
  },
};

export const menuItemIconSx = {
  width: appThemeSize.menuIcon,
  height: appThemeSize.menuIcon,
  color: appThemeColors.text.muted,
  flex: "0 0 auto",
};

export const menuItemChevronSx = {
  width: appThemeSize.menuChevron,
  height: appThemeSize.menuChevron,
  color: appThemeColors.text.faint,
  marginLeft: "auto",
};

export const getChevronRotatedSx = (isOpen) => ({
  ...menuItemChevronSx,
  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
  transition: appThemeTransition.chevron,
});

export const menuItemLabelGrowSx = {
  flex: 1,
};

export const menuTitleSx = {
  ...appTypography.menuTitle,
  color: appThemeColors.text.heading,
};

export const menuSubTextSx = {
  fontFamily: appThemeFonts.family.ui,
  fontSize: appThemeFonts.size.mdPlus,
  fontWeight: appThemeFonts.weight.regular,
  color: appThemeColors.text.muted,
};
